import { render, staticRenderFns } from "./BaseTest.vue?vue&type=template&id=7951165c&scoped=true&"
import script from "./BaseTest.vue?vue&type=script&lang=js&"
export * from "./BaseTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7951165c",
  null
  
)

export default component.exports